import React, { useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../config/apiConfig";
import "./ReportModal.css";

const ReportModal = ({
  isOpen,
  onClose,
  contentType, // 'post' | 'comment' | 'reply'
  contentId, // For post: "postId", for comment: {postId, commentId}, for reply: {postId, commentId, replyId}
}) => {
  const [reason, setReason] = useState("spam");
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const user = JSON.parse(localStorage.getItem("user"));

      await axios.post(
        `${API_BASE_URL}/reports`,
        {
          contentType,
          contentId,
          reason,
          description: description.trim(),
        },
        {
          headers: { Authorization: `Bearer ${user?.token}` },
        }
      );

      alert("Report submitted successfully. Our team will review it shortly.");
      onClose();
    } catch (error) {
      alert("Failed to submit report. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  const contentTypeLabel =
    contentType.charAt(0).toUpperCase() + contentType.slice(1);

  return (
    <div className="rpm-overlay" onClick={onClose}>
      <div className="rpm-content" onClick={(e) => e.stopPropagation()}>
        <div className="rpm-header">
          <h3 className="rpm-title">Report {contentTypeLabel}</h3>
          <button
            className="rpm-close-btn"
            onClick={onClose}
            aria-label="Close"
          >
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit} className="report-form">
          <div className="form-group">
            <label htmlFor="reason">Reason for reporting</label>
            <select
              id="reason"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              required
            >
              <option value="spam">Spam</option>
              <option value="harassment">Harassment or Bullying</option>
              <option value="misinformation">Misinformation</option>
              <option value="inappropriate">Inappropriate Content</option>
              <option value="other">Other</option>
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="description">Additional details (optional)</label>
            <textarea
              id="description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              rows={4}
              maxLength={500}
              placeholder="Provide additional context to help us understand your report..."
            />
            <div className="char-count">{description.length}/500</div>
          </div>

          <div className="report-disclaimer">
            <p>⚠️ False reports may result in action against your account.</p>
          </div>

          <div className="rpm-actions">
            <button
              type="button"
              onClick={onClose}
              className="rpm-cancel-btn"
              disabled={loading}
            >
              Cancel
            </button>
            <button type="submit" className="rpm-submit-btn" disabled={loading}>
              {loading ? "Submitting..." : "Submit Report"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ReportModal;
